import Layout from '@/layout'
// import routerView from '@/layout/routerView.vue'
const taskManageRouter = {
  path: '/taskManage',
  component: Layout,
  redirect: '/taskManage/mine',
  name: 'taskManage',
  permissionCode: '59705',
  meta: {
    title: '任务管理',
    icon: 'nav-task'
  },
  children: [
    {
      path: 'mine',
      component: () => import('@/views/taskManage/page/mine.vue'),
      name: 'taskManageMine',
      permissionCode: '37110',
      meta: { title: '我的流程' }
    },
    {
      path: 'pending',
      component: () => import('@/views/taskManage/page/pending.vue'),
      name: 'taskManagePending',
      permissionCode: '42931',
      meta: { title: '待办' }
    },
    {
      path: 'finished',
      component: () => import('@/views/taskManage/page/finished.vue'),
      name: 'taskManageFinished',
      permissionCode: '13957',
      meta: { title: '已办' }
    },
    {
      path: 'copy',
      component: () => import('@/views/taskManage/page/copy.vue'),
      name: 'taskManageCopy',
      permissionCode: '52273',
      meta: { title: '抄送' }
    },
    {
      path: 'draft',
      component: () => import('@/views/taskManage/page/draft.vue'),
      name: 'taskManageDraft',
      permissionCode: '18905',
      meta: { title: '我的草稿' }
    }
  ]
}
export default taskManageRouter
